"use client";

import type { Menu } from "@packages/sdk";
import { usePathMatch } from "@packages/sdk";
import { Footer as FooterComponent, MinimalFooter } from "@packages/ui/emotion";
import type { HTMLAttributes } from "react";

import { WEB_APP_FULL_SCREEN_ROUTES } from "../lib/constants/routes.constants";

type FooterProps = Omit<HTMLAttributes<HTMLDivElement>, "children"> & {
  menu?: Menu;
};

const MINIMAL_FOOTER_ROUTES = [
  "/upgrade/subscribe",
  "/web/subscribe",
  "/upgrade/checkout",
  "/support-the-mission",
];

const FOOTER_HIDDEN_ROUTES = [...WEB_APP_FULL_SCREEN_ROUTES];

export const Footer = ({ menu, ...props }: FooterProps) => {
  const matcher = usePathMatch();
  const isFooterHidden = FOOTER_HIDDEN_ROUTES.some((route) => matcher(route));
  if (isFooterHidden) return null;

  const isMinimalFooter = MINIMAL_FOOTER_ROUTES.some((route) => matcher(route));
  if (isMinimalFooter) return <MinimalFooter {...props} />;
  return <FooterComponent menu={menu} {...props} />;
};
